import { BulletsData, DynamicContentType } from '@bm-js/atlascloud-shared'
import { useMargin } from '../utils/hooks'
import { Icon } from './Icon'

type Props = {
  content: DynamicContentType<BulletsData>
}

export const BulletPoints = ({ content }: Props) => {
  const margin = useMargin(content)

  return (
    <div className={`${margin} space-y-4`}>
      {content.data.bullets.map((bullet, i) => (
        <div
          key={`bulletItem_${content.uuid}_${i}`}
          className='flex items-center gap-4'
        >
          <Icon name={bullet.icon} className='size-5 shrink-0' />
          <p className='text-base font-light'>{bullet.text}</p>
        </div>
      ))}
    </div>
  )
}
